<template>
    <div v-cloak class="Resource bg-round bg-fff">
        <!-- 头部banner图 -->
        <!-- <div class="swiper">
            <div class="toptexts">
                <div class="imgtitle">国际影展</div>
                <div class="texts">新鲜资讯、随时播报、一网打尽</div>
            </div>
        </div> -->

        <!-- 中间内容 -->
        <div class="container" id="w-1200px">
            <div class="pa-t-30 ma-b-20">
                <Bread />
            </div>
            <el-tabs @tab-click="handleClick" v-model="activeName">
                <div class="flex f-between">
                    <div></div>
                    <!-- <Bread :list="breadList" /> -->
                    <div class="flex">
                        <div @click="isHot" class="pointer ma-r-40">
                            <div class="c-8a flex f-center" v-show="sortType != 2">
                                <img src="../img/redu.png" class="img_22 ma-r-10" />按热度排序
                            </div>
                            <div class="c-234775 flex f-center" v-show="sortType == 2">
                                <img src="../img/redu2.png" class="img_22 ma-r-10" />按热度排序
                            </div>
                        </div>
                        <div @click="isDate" class="pointer">
                            <div class="c-8a flex f-center" v-show="sortType != 1">
                                <img src="../img/riqi.png" class="img_22 ma-r-10" />按日期排序
                            </div>
                            <div class="c-234775 flex f-center" v-show="sortType == 1">
                                <img src="../img/riqi2.png" class="img_22 ma-r-10" />按日期排序
                            </div>
                        </div>
                    </div>
                </div>
                <el-tab-pane v-for="kind in kinds"
                             :key="kind.Id"
                             :label="kind.Name"
                             :name="kind.Id"></el-tab-pane>
                <div ref="cp">
                    <!-- 星辰资讯 -->
                    <div class="three_box ma-center">
                        <div class="flex f-center f-wrap ma-t-40 f-between">
                            <div class="resource-boxs ma-t-30 height302"
                                 v-for="(item, index) in dataList.List"
                                 :key="index"
                                 @click="toDetail(item.Id)">
                                <!-- <img :src="item.Image" class="img_263" /> -->

                                <div class="t-omit-2 ma-t-10  fon-16 weight500 height40">
                                    {{ item.Name }}
                                </div>
                                <div class="c-8a ma-t-12  fon-14 flex f-between">
                                    {{ item.ReleaseTime }}
                                    <div class="c-8a fon-14 flex f-center">
                                        {{ item.ViewCount }}人浏览
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="dataList.List && dataList.List.length == 0" class="width100">
                            <div class="t-center ma-t-40">
                                <img src="../img/empty.png" alt="" srcset="" width="200" />
                                <div class="c-999 ma-t-20">暂无数据</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="fy">
                    <el-pagination @current-change="handleCurrentChange"
                                   :hide-on-single-page="true"
                                   :current-page.sync="pageIndex"
                                   :page-size="pageSize"
                                   layout="prev, pager, next, jumper"
                                   :total="totals"></el-pagination>
                </div>
            </el-tabs>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        #w-1200px {
            width: 1200px;
        }

        .el-tabs--top {
            width: 100%;
        }

        .c-8a {
            color: #8a8a8a;
        }

        .c-009294 {
            color: #fb004d;
        }

        .img_22 {
            width: 22px;
            height: 22px;
        }

        .ma-lr-15 {
            margin: 0 18px;
        }

        .c-41 {
            color: #414141;
        }

        .rz {
            width: 50%;
            margin: 15px auto;
            border-radius: 3px;
            text-align: center;
            padding: 10px 10px;
            background-color: #e6e6e6;
            color: #000;
            font-weight: 500;
        }

        .containerss {
            width: 1200px;
            margin: 0 auto;
            background: #ffffff;
            padding: 0px 14px 25px 14px;
            box-sizing: border-box;

            .fy {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .product-main {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .product-list {
                    width: 370px;
                    height: 121px;
                    margin-right: 20px;
                    margin-bottom: 38px;
                    display: flex;
                    justify-content: flex-start;

                    .p-image {
                        width: 35%;
                        height: 121px;
                        margin-right: 9px;

                        .p-imgs {
                            width: 121px;
                            height: 121px;
                            border-radius: 10px;
                        }
                    }

                    .p-title {
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        color: rgba(102, 102, 102, 1);
                        margin-bottom: 8px;
                    }

                    .p-detail {
                        // width:100%;
                        font-size: 14px;
                        height: 38px;
                        line-height: 19px;
                        font-family: MicrosoftYaHei;
                        color: rgba(102, 102, 102, 1);
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }

                    .p-right {
                        width: 65%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }

                    .download {
                        width: 90px;
                        height: 30px;
                        background: rgba(15, 117, 189, 1);
                        border-radius: 20px;
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: rgba(255, 255, 255, 1);
                        text-align: center;
                        line-height: 30px;
                        cursor: pointer;
                        text-decoration: none;
                    }
                }
            }
        }

        @media screen and (min-width: 600px) {
            .Resource {
                min-width: 1200px;
                // background: rgba(245, 247, 250, 1);
            }
        }

        .Resource .swiper {
            width: 100%;
            height: 314px;
            background-image: url(../img/资讯.png);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            position: relative;

            .toptexts {
                width: 736px;
                position: absolute;
                top: 28%;
                margin: 0 auto;
                left: 50%;
                margin-left: -368px;
                font-size: 20px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                color: #fff;
                // opacity: 0.75;
                text-align: center;

                .texts {
                    line-height: 30px;
                    letter-spacing: 3px;
                    font-size: 16px;
                }

                .imgtitle {
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
        }

        .fy {
            margin-top: 55px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        

        .Resource .container {
            .el-tabs__header {
                display: flex;
                justify-content: center;
            }

            .el-tabs__content {
                min-width: 1080px;
                margin: 0 auto;
            }

            .el-tabs__item {
                padding: 0 60px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #333333;
            }

            .el-tabs__active-bar {
                height: 4px;
                font-weight: bold;
                background: #fb004d;
            }

            .is-active {
                font-size: 14px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #fb004d;
            }

            .el-tabs__content {
                margin-top: 45px;
            }
        }

        .Resource .student {
            width: 1100px;
            height: 106px;
            margin-bottom: 32px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;

            .img-left {
                width: 20%;
                height: 106px;

                .img-lefts {
                    width: 187px;
                    height: 106px;
                }
            }

            .text-right {
                width: 80%;

                .title {
                    font-size: 14px;
                    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                    font-weight: bold;
                    color: #333333;
                    margin-top: 3px;
                    margin-bottom: 5px;
                }

                .text-detail {
                    padding-right: 100px;
                    box-sizing: border-box;
                    font-size: 12px;
                    line-height: 18px;
                    font-family: MicrosoftYaHei;
                    color: rgba(102, 102, 102, 1);
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                .icons {
                    // width: 100%;
                    margin-top: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .deletes {
                        font-size: 12px;
                        font-family: MicrosoftYaHei;
                        color: rgba(102, 102, 102, 1);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .icons-right-children {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            i {
                                font-size: 18px;
                            }
                        }
                    }

                    .icons-left {
                        width: 100%;
                        padding-right: 100px;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .icons-left-children {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            div {
                                font-size: 12px;
                                font-family: MicrosoftYaHei;
                                color: rgba(102, 102, 102, 1);
                                margin-left: 8px;
                            }
                        }
                    }

                    .delete-right {
                        width: 40%;

                        .icons-right-children {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            div {
                                font-size: 12px;
                                font-family: MicrosoftYaHei;
                                color: rgba(102, 102, 102, 1);
                                margin-left: 8px;
                            }
                        }
                    }
                }
            }
        }

        .three_box {
            width: 100%;
            height: auto;
            margin-top: 36px;

            .resource-boxs {
                width: 100%;
                margin: 0 auto;
                border-bottom: 1px solid #e6e6e6;
                padding-bottom: 10px;
                cursor: pointer;
            }

            .boxs {
                width: 240px;
                height: 302px;
                background: #ffffff;
                box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
                border-radius: 10px;
                position: relative;

                .img_263 {
                    width: 240px;
                    height: 220px;
                }

                .img_30 {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    position: absolute;
                    top: 205px;
                    left: 10px;
                }
            }
        }

        .ma-t-60 {
            margin-top: 60px !important;
        }

        .ma-t-10 {
            margin-top: 10px !important;
        }

        .ma-t-12 {
            margin-top: 12px !important;
        }

        .height40 {
            height: 36px;
        }

        .c-234775 {
            color: #fb004d;
        }
    }
</style>
<script>
    import { newsCategory, newsList } from "../api.js";
    // import Bread from "../components/Bread.vue";

    // studycollect
    export default {
        name: "Resource",
        components: {
            // Bread,
        },
        data() {
            return {
                activeName: "",
                pageIndex: 1,
                pageSize: 16,
                totals: 0, //一个分类下的总条数
                dataList: [],
                kinds: [],
                breadList: [{ name: "国际影展", path: "/competition/winner" }],
                sortType: 0,
            };
        },

        created() {
            // let token = localStorage.getItem('AccessToken');

            newsCategory().then((res) => {
                this.kinds = res.data.Data;
                this.activeName = res.data.Data[0].Id;
                this.getList();
            });
        },
        // 其他页面进来时更新初始数据
        activated() { },

        methods: {
            isDate() {
                if (this.sortType == 1) {
                    this.sortType = 0;
                } else if (this.sortType == 2) {
                    this.sortType = 1;
                } else {
                    this.sortType = 1;
                }

                this.getList();
            },
            isHot() {
                if (this.sortType == 2) {
                    this.sortType = 0;
                } else if (this.sortType == 1) {
                    this.sortType = 2;
                } else {
                    this.sortType = 2;
                }
                this.getList();
            },
            getList() {
                let data = {
                    categoryId: this.activeName,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    sortType: this.sortType,
                };
                newsList(data).then((res) => {
                    if (res.data.Code == 0) {
                        this.dataList = res.data.Data;

                        this.totals = res.data.Data.TotalCount;
                    }
                });
            },

            toDetail(id = 1) {
                window.open('/competition/winner/detail?id=' + id )
            },

            //点击切换种类
            handleClick() {
                // console.log(tab);

                this.pageIndex = 1;
                this.sortType = 0;
                this.getList();
            },

            upload(e) {
                window.open(e, "_blank");
            },

            // 设置保存页码
            save() {
                let kinds = this.kinds;
                this.saves = kinds.map((item) => {
                    return { id: item.Id, page: 1 };
                });
            },

            // 详情
            collect(id) {
                this.$router.push({
                    path: "/competition/winner/detail",
                    query: { paths: "/competition/winner", name: "学习资源", id: id },
                });
            },

            // 当前页改变时触发
            handleCurrentChange(e) {
                this.pageIndex = e;
                this.getList();
            },
        },
    };
</script>
